import { getTopicById, getArticleStructure } from "./api";
import { useQuery } from "../_app/lib/query";

export function useArticleTopic(id: string, options = {}) {
  return useQuery({
    queryKey: ["articleTopic", id],
    queryFn: () => getTopicById(id),
    ...options,
  });
}

export function useArticleStructure(options = {}) {
  return useQuery({
    queryKey: ["articleStructure"],
    queryFn: () => getArticleStructure(),
    ...options,
  });
}
